// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"289":"74d566d0910bdfb9","341":"248f752197060b7b","472":"8a187b90a4661754"}[chunkId] + ".js";
};